import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {catchError, debounceTime, distinctUntilChanged, map, tap, switchMap} from 'rxjs/operators';
import { environment } from './../../../../src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class IncoTermService {

  constructor(private http:HttpClient) { }
  
  API_KEY = environment.API_KEY;
  URL_1 = environment.INCO_URL_1;
  URL_2 = environment.INCO_URL_2;
 

  getINCOList():Observable<any>{
   let obj = {
    API_KEY:this.API_KEY
   }
    return  this.http.post(this.URL_1,obj);
  }

  getINCODetails(obj:any):Observable<any>{
    obj.API_KEY = this.API_KEY;
    return  this.http.post(this.URL_2,obj);
  }


}
